import React from 'react'

import { HouseNightlyTripIndividualFlexibleSchedule } from './components/flexible-schedule-field/HouseNightlyTripIndividualFlexibleSchedule'
import HouseNightlyTripGlobalHouseHoldFields from './components/house-hold/HouseNightlyTripGlobalHouseHoldFields'
import { HouseNightlyTripGlobalSeasonalPricesFields } from './components/seasonal-prices-fields/HouseNightlyTripGlobalSeasonalPricesFields'
import { HouseNightlyTripGlobalTouristTaxField } from './components/tourist-tax/HouseNightlyTripGlobalTouristTaxField'
import { HouseNightlyTripGlobalVatField } from './components/vat-field/HouseNightlyTripGlobalVatField'
import { HouseNightlyTripGlobalFieldProps } from '../form-container/HouseNightlyTripGlobalFormContainer'
import { Divider } from '../../../../../../../atoms/divider/Divider'
export const HouseNightlyTripGlobalOptionsFields = ({
  currencyArea,
  ...fieldProps
}: HouseNightlyTripGlobalFieldProps) => {
  return (
    <>
      <Divider />

      <HouseNightlyTripGlobalSeasonalPricesFields
        {...fieldProps}
        currencyArea={currencyArea}
      />

      <Divider />

      <HouseNightlyTripGlobalVatField
        {...fieldProps}
        currencyArea={currencyArea}
        name='options.vatRate'
      />

      <Divider />

      <HouseNightlyTripIndividualFlexibleSchedule
        {...fieldProps}
        currencyArea={currencyArea}
      />

      <Divider />

      <HouseNightlyTripGlobalVatField
        {...fieldProps}
        currencyArea={currencyArea}
        name='options.flexibleSchedule.vatRate'
      />

      <Divider />

      <HouseNightlyTripGlobalTouristTaxField
        {...fieldProps}
        currencyArea={currencyArea}
      />

      <Divider />

      <HouseNightlyTripGlobalHouseHoldFields
        {...fieldProps}
        currencyArea={currencyArea}
      />
    </>
  )
}
